import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import {
  alerts,
  documentManagement,
  confirmDialog,
} from 'app/components/global';

import vendorManagementNavigationService from '../../../../services';

import controller from './perform-controls-review-dialog.controller';
import template from './perform-controls-review-dialog.html';

import riskControlReviewTaskControlSchemeMessagesTpl from './messages/risk-control-review-task-control.scheme.messages.html';
import riskControlReviewTaskControlQuestionMessagesTpl from './messages/risk-control-review-task-control.question.messages.html';

class dialogService {
  getOptions($event, {
    vendor, product, currentControlsReviewTask, selectRiskControlsForReviewDialog
  }) {
    return {
      controller,
      controllerAs: 'performControlsReviewDialogVM',
      locals: {
        vendor,
        product,
        currentControlsReviewTask,
        selectRiskControlsForReviewDialog
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.performControlsReviewDialog', [
  alerts,
  confirmDialog,
  constants,
  documentManagement,
  loaderService,
  ssDialogService,
  vmDataService,
  vendorManagementNavigationService,
])
  .service('performControlsReviewDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('risk-control-review-task-control.scheme.messages.html', riskControlReviewTaskControlSchemeMessagesTpl);
    $templateCache.put('risk-control-review-task-control.question.messages.html', riskControlReviewTaskControlQuestionMessagesTpl);
  })
  .name;
